export const getVehicleImageUrl = (stockNumber: string) =>
  `${process.env.VEHICLE_IMAGE_CDN_URL}/${stockNumber}/post-large/${stockNumber}-edc-02-search.jpg`;

export const getCloseUpVehicleImageUrl = (stockNumber: string) =>
  `${process.env.VEHICLE_IMAGE_CDN_URL}/${stockNumber}/post-large/normalized/zoomcrop/${stockNumber}-edc-02.jpg`;
